import { useQuery } from '@tanstack/react-query'
import type { StageInfo } from '@concours/shared'
import { useAuth } from '@concours/ui'

/** Moteur de sélection (phase 13) : parcours d'un concours et catalogue des disciplines. */
export const SELECTION_KEY = ['admin', 'selection'] as const

export interface SelectionOverview {
  competition: {
    id: string
    reference: string
    title: string
    session: string
    status: string
    seats: number
  }
  stages: StageInfo[]
}

export interface CatalogueDiscipline {
  id: string
  code: string
  label: string
  description: string | null
  isActive: boolean
}

export function useSelection(competitionId: string, enabled = true) {
  const { session } = useAuth()
  return useQuery({
    queryKey: [...SELECTION_KEY, competitionId],
    queryFn: () =>
      session.api.get<SelectionOverview>(`/admin/competitions/${competitionId}/stages`),
    enabled: enabled && Boolean(competitionId),
  })
}

export function useCatalogue() {
  const { session } = useAuth()
  return useQuery({
    queryKey: [...SELECTION_KEY, 'disciplines'],
    queryFn: () =>
      session.api.get<{ data: CatalogueDiscipline[] }>('/admin/disciplines').then((r) => r.data),
    staleTime: 30_000,
  })
}

/** `datetime-local` ↔ ISO. */
export const toLocalInput = (iso: string | null) => {
  if (!iso) return ''
  const d = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}
export const fromLocalInput = (value: string) => (value ? new Date(value).toISOString() : null)
